import React, { Component } from "react";
import CSVSVGReceive from "../../../Assets/svg/CSVSVGRecieve.svg";
import { SendToMail, RenderOnSite } from "../../../Actions/Analysis";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { withRouterHooks } from "../../../withRouters/withRoutersHook";

class CSVReceiveMethodPopUp extends Component {
  static propTypes = {
    SendToMail: PropTypes.func.isRequired,
    RenderOnSite: PropTypes.func.isRequired,
    GetUserAction: PropTypes.func.isRequired,
  };

  handleSendToMail = () => {
    this.props.SendToMail();
  };

  handleRenderOnSite = () => {
    this.props.RenderOnSite();
  };
  render() {
    return (
      <div className="flex flex-col gap-6 w-full max-w-md bg-white rounded-2xl p-8 items-center z-100 shadow-custom-shadow border border-blue-100"
        style={{ background: "linear-gradient(135deg, #ffffff 0%, #eff6ff 100%)" }}
      >
        <img
          src={CSVSVGReceive}
          alt="AccountCreatedSuccessSVG"
          className="w-16 h-16"
        />
        <div className="font-semibold font-inter text-lg text-gray-900 text-center leading-snug">
          Where would you like to receive your analyzed data?
        </div>
        <div className="flex w-full gap-3 font-inter">
          <button
            onClick={this.handleSendToMail}
            className="flex-1 py-2.5 rounded-lg bg-gradient-to-r from-gray-50 to-gray-100 border border-gray-200 text-sm font-medium text-gray-700 hover:from-gray-100 hover:to-gray-200 hover:text-gray-900 transition-all duration-150"
          >
            Email
          </button>
          <button
            onClick={this.handleRenderOnSite}
            className="flex-1 py-2.5 rounded-lg bg-gradient-to-r from-primary-blue to-blue-400 text-white text-sm font-medium hover:from-blue-600 hover:to-blue-500 transition-all duration-150 shadow-sm"
          >
            Here in the App
          </button>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  csvAnalysisSuccess: state.analysis.csvAnalysisSuccess,
  isSentToMail: state.analysis.isSentToMail,
  isRenderOnSite: state.analysis.isRenderOnSite,
  user: state.authentication.user,
  userFetchSuccess: state.authentication.userFetchSuccess,
});

export default withRouterHooks(
  connect(mapStateToProps, { SendToMail, RenderOnSite })(CSVReceiveMethodPopUp)
);
